'use client';

import { cn } from '@/lib/utils';
import { useRef, useState } from 'react';

interface SectionCardProps {
  children: React.ReactNode;
  className?: string;
  withGradient?: boolean;
  paddingClassName?: string;
  withSpotlight?: boolean;
}

export function SectionCard({ children, className, withGradient = false, paddingClassName, withSpotlight = true }: SectionCardProps) {
  const cardRef = useRef<HTMLDivElement>(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    setMousePosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  return (
    <div 
      ref={cardRef}
      className={cn('card-gradient-border rounded-3xl', className)}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={cn('relative h-full bg-black/40 backdrop-blur-sm rounded-3xl', paddingClassName || 'p-8')}>
        {/* Spotlight effect */}
        {withSpotlight && (
          <div
            className='absolute inset-0 rounded-3xl pointer-events-none transition-opacity duration-300'
            style={{
              background: `radial-gradient(500px circle at ${mousePosition.x}px ${mousePosition.y}px, rgba(120, 100, 255, 0.2), transparent 40%)`,
              opacity: isHovered ? 1 : 0,
            }}
          />
        )}
        {withGradient && (
          <div
            className='absolute inset-0 rounded-3xl pointer-events-none'
            style={{
              background: 'linear-gradient(180deg, hsla(0, 0%, 100%, 0.05) 0%, hsla(0, 0%, 100%, 0.1) 100%)',
            }}
          />
        )}
        <div className={cn('relative flex flex-col gap-12', (withGradient || withSpotlight) && 'z-10')}>{children}</div>
      </div>
    </div>
  );
}
